// extracted by mini-css-extract-plugin
export default {"zoomModal":"d2-z"};